import { render, staticRenderFns } from "./messageList.vue?vue&type=template&id=54134bad"
import script from "./messageList.vue?vue&type=script&lang=js"
export * from "./messageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports